import { commentsData } from '@/mocks/homeData';

export default function SectionComments() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            读者热评
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            精选吃瓜群众的精彩评论，看看大家都在讨论什么
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 relative"
            >
              {comment.tag && (
                <span className="absolute top-3 right-3 px-2 py-0.5 rounded text-xs font-medium bg-primary-100 text-primary-700">
                  {comment.tag}
                </span>
              )}
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.nickname}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-950">{comment.nickname}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}